import React from "react";
import Icon from "../Icon";
import { SmartLink } from "../../v2/SmartLink/SmartLink";
import { SmartImage } from "@/src/components/v2/SmartImage/SmartImage";
import { IDetailPreviewCard } from "@/src/@types/blog";

const SliderPreviewCard = ({ content }: { content: IDetailPreviewCard }) => {
    const { title, description, image, externalImage, imageAlt, url, categoryName, categoryIconURL, readMoreCta, timestamp } = content;
    const imageSource = image ?? externalImage;

    return (
        <div className="relative">
            <SmartLink href={url} aria-label={title} className="absolute z-10 h-full w-full rounded-2xl md:rounded-3xl">
                <span className="sr-only">{title}</span>
            </SmartLink>
            <div className="relative flex h-full flex-col overflow-hidden rounded-2xl border border-border-light shadow-md md:flex-row md:rounded-3xl">
                {/* Card Image Container */}
                <div className="relative h-[200px] md:h-auto md:min-w-[300px] lg:min-w-[564px]">
                    {/* Image */}
                    {imageSource && (
                        <div className="relative h-full w-full">
                            <SmartImage image={imageSource} alt={imageAlt ?? ""} objectPosition="center" fill objectFit="cover" />
                        </div>
                    )}
                    {/* Category label mobile */}
                    {categoryName && (
                        <div className="absolute bottom-0 left-1/2 flex w-fit -translate-x-1/2 transform items-center gap-1 overflow-hidden rounded-t-xl bg-accent-secondary-ada px-4 py-2 text-text-contrast md:hidden">
                            {categoryIconURL && <SmartImage image={categoryIconURL} width={20} height={20} alt="" className="brightness-0 invert max-[490px]:hidden" />}
                            <p className="whitespace-nowrap font-bold">{categoryName}</p>
                        </div>
                    )}
                </div>
                {/* Card Body  */}
                <div className="flex grow flex-col justify-between gap-6 bg-background-surface p-6 text-text-primary md:p-8 md:pt-0">
                    {/* Card Body Content  */}
                    <div className="flex flex-col gap-6">
                        {/* Category label desktop */}
                        {categoryName && (
                            <div className="hidden w-fit items-center gap-1 overflow-hidden rounded-b-xl bg-accent-secondary-ada px-4 py-2 text-text-contrast md:flex">
                                {categoryIconURL && (
                                    <SmartImage
                                        image={categoryIconURL}
                                        width={20}
                                        height={20}
                                        alt=""
                                        className="brightness-0 invert"
                                        style={{
                                            maxWidth: "100%",
                                            height: "auto"
                                        }}
                                    />
                                )}
                                <p className="whitespace-nowrap font-bold">{categoryName}</p>
                            </div>
                        )}
                        <div className="flex flex-col gap-1">
                            <h3 className="text-[20px] font-extrabold md:text-[24px] md:font-bold lg:text-4xl">{title}</h3>
                            {description && <p className="line-clamp-3 text-[12px] leading-[18px] md:flex md:text-[14px] md:leading-[22px]">{description}</p>}
                        </div>
                    </div>
                    {/* Card Body Footer  */}
                    <div className="flex items-center justify-between text-[14px]">
                        {readMoreCta && (
                            <div className="hidden items-center gap-1 font-bold text-accent-primary-ada underline md:flex">
                                <span>Read More</span>
                                <Icon type="rightarrow" />
                            </div>
                        )}
                        {timestamp && <div className="text-accent-secondary-ada">{timestamp}</div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SliderPreviewCard;
